import Dropdown from "shared/components/inputs/form-fields/Dropdown";
import HStack from "shared/components/layout/stack/HStack";
import PropTypes from "prop-types";
import React from "react";
import Text from "shared/components/data-display/text/Text";
import TextAutocomplete from "shared/components/inputs/form-fields/TextAutocomplete";
import VStack from "shared/components/layout/stack/VStack";
import { useAccessGroupMembersApiEmployees } from "features/admin/access-groups/single/useAccessGroupMembers";
import { useWatch } from "react-hook-form";
import { EmployeeCard, StyledImg } from "./AccessGroupMemberFormShowDropdown.styles";

const SelectedEmployeeCard = () => {
    const { employees } = useAccessGroupMembersApiEmployees();
    const employeeId = useWatch({ name: "employee" });

    if (employeeId && employees.isLoading) {
        return <div>Loading...</div>;
    }

    if (employeeId && employees.isError) {
        return <div>Error</div>;
    }

    const selectedEmployee = employees.data?.find(
        (employee) => employee.NewId === employeeId
    );

    return selectedEmployee ? (
        <VStack spacing="Zero_5">
            <Text variant="Headline_5" color="Gray_1">
                Selection
            </Text>
            <EmployeeCard>
                <HStack align="center" spacing="Zero_75">
                    <StyledImg
                        alt={selectedEmployee.FullName}
                        url={`https://reporter.ny.rga.com/${selectedEmployee.PhotoURL}`}
                    />
                    <div>
                        <Text variant="Headline_5" color="Black">
                            {selectedEmployee.FullName}
                        </Text>
                        <Text variant="Descriptive_1_1" color="Gray_2">
                            {selectedEmployee.Title}
                        </Text>
                        <Text variant="Descriptive_1_1" color="Gray_3">
                            {selectedEmployee.Office}
                        </Text>
                    </div>
                </HStack>
            </EmployeeCard>
        </VStack>
    ) : (
        <></>
    );
};

const AccessGroupMemberFormShowDropdown = ({
    employeesDataLoading,
    departmentsDataLoading,
    employeesDropdownOptions,
    departmentsDropdownOptions,
    existingEmployeesList = [],
    existingDepartmentsList = [],
}) => {
    const selectedRadioButton = useWatch({
        name: "memberTypeName",
    });

    switch (selectedRadioButton) {
        case "Employee":
            return (
                <>
                    <TextAutocomplete
                        name="employee"
                        label="Select an Employee"
                        validations={{
                            required: true,
                        }}
                        placeholder="Search by Name"
                        items={employeesDropdownOptions}
                        itemsAreLoading={employeesDataLoading}
                        showClearIcon={true}
                        clearDataOnUnmount={true}
                        disabledOptionsList={existingEmployeesList}
                        disabledOptionTooltipText="Already in this Access Group"
                        position="relative"
                    />
                    <SelectedEmployeeCard />
                </>
            );
        case "Department":
            return (
                <Dropdown
                    name="department"
                    label="Select a Department"
                    validations={{
                        required: true,
                    }}
                    placeholder="Departments"
                    options={departmentsDropdownOptions}
                    clearDataOnUnmount={true}
                    itemsAreLoading={departmentsDataLoading}
                    disabledOptionsList={existingDepartmentsList}
                    disabledOptionTooltipText="Already in this Access Group"
                />
            );

        default:
            return <></>;
    }
};

AccessGroupMemberFormShowDropdown.propTypes = {
    employeesDataLoading: PropTypes.bool.isRequired,
    departmentsDataLoading: PropTypes.bool.isRequired,
    employeesDropdownOptions: PropTypes.array.isRequired,
    departmentsDropdownOptions: PropTypes.array.isRequired,
    existingEmployeesList: PropTypes.array,
    existingDepartmentsList: PropTypes.array
};

export default AccessGroupMemberFormShowDropdown;
